
const mLNameMax = new WeakMap();
const mFNameMax = new WeakMap();

const mFirstName = new WeakMap();
const mLastName = new WeakMap();

function checkString(s, sMax) {
    if (s == null) {
        return null;
    }

    if (typeof s === "string") {
        if (s.length <= sMax) { return s; }
    }

    return undefined; //This is implicitly true, but making it explicit for readability;
}

class TargetName {
    constructor(lName, fName) {

        mLNameMax.set(this, 100);
        mFNameMax.set(this, 100);

        let chkLName = checkString(lName, mLNameMax.get(this));

        if (chkLName !== undefined) { //Null is ok.
            mLastName.set(this, chkLName);
        }
        else {
            throw new TypeError("Last name parameter is invalid or too long");
        }

        if (this.lastName == null) {
            mFirstName.set(this, null); //If last name is null, both must be null (not vice-versa, though).
        }
        else {
            let chkFName = checkString(fName, mFNameMax.get(this));
            if (chkFName !== undefined) {
                mFirstName.set(this, chkFName);
            }
            else {
                throw new TypeError("First name parameter is invalid or too long");
            }
        }
    }

    get lastNameMax() {
        return mLNameMax.get(this);
    }

    get firstNameMax() {
        return mFNameMax.get(this);
    }

    get lastName() {
        return mLastName.get(this);
    }

    set lastName(updatedLastName) {
        let checkName = checkString(updatedLastName, mLNameMax.get(this));
        if (checkName !== undefined) {
            mLastName.set(this, checkName);

            if (checkName == null) {
                mFirstName.set(this, null);
            }

        }
    }

    get firstName() {
        return mFirstName.get(this);
    }

    set firstName(updatedFirstName) {
        let checkName = checkString(updatedFirstName, mFNameMax.get(this));
        if (checkName !== undefined) {
            mFirstName.set(this, checkName);
        }
    }

    toString() {
        return `${this.lastName}/${this.firstName}`;
    }
}

export default TargetName;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-targets-view/TargetName.js
// module id = lFpQ
// module chunks = 1